import React from 'react';
import cn from 'classnames';

type Props = {
  title?: string
  className?: string
}

export default function DropdownMenuSection({title, className, children}: React.PropsWithChildren<Props>) {
  return (
    <div className={cn('flex flex-col border-b-2 border-gray-light pt-2 pb-1', className)}>
      { !!title && ( <div className="text-gray-dark py-2 px-5">{title}</div> )}
      {children}
    </div>
  )
}
